<template>
    <div class="raffle-main">
        <login-in :loginType="loginType"
            :isLoginFlag="isLoginFlag"
            :activityTypeFlag="activityTypeFlag"
            :activityUrl="activityUrl"
            :isMemberId="isMemberId"></login-in>
        <!-- 业务不需要返回小程序页面按钮，暂时隐藏  -->
        <!-- <div v-if="miniprogramFlag && isShowBackBtn class="xcx-back-btn"
            @click="goHiHonorMiniProgram('my')">
            <img src="static/runtime/images/magic/award/xcxBack.png"
                alt=""
                style="width: 100%;">
        </div> -->
        <!-- 头部所选的门店区域  -->
        <top-store-display v-if="showTopStore"
            :currentStore="currentStore"
            @changeStore='selectStore'
            @navToStore="navToStore"></top-store-display>
        <!-- 大转盘  -->
        <div v-if="bigWheelActivityType === '1'">
            <big-wheel :isLoginFlag="isLoginFlag"
                :activityObj="activityObj"
                :bannerPic="bannerPic"
                :bgColor="bgColor"
                :drawWheelUrl="drawWheelUrl"
                :activityStatus="activityStatus"
                :drawPointUrl="drawPointUrl"
                :pointDrawFlag="pointDrawFlag"
                :canDrawFlag="canDrawFlag"
                :drawType="drawType"
                :turnplate="turnplate"
                :participateTimes="Number(participateTimes)"
                :winnerList="winnerList"
                :tigerLottery="tigerLottery"
                :memberInfo="memberInfo"
                :myRecord="myRecord"
                :myRecords="myRecords"
                :bigWheelRewardList="bigWheelRewardList"
                :ruleDesci="ruleDesci"
                :pointsValue="pointsValue"
                :bigWheelActivityType="bigWheelActivityType"
                :sectionThreeColor="sectionThreeColor"
                :activityUrl="activityUrl"
                :drawPointConsumption="drawPointConsumption"
                :poinsOrDiamonds="poinsOrDiamonds"
                :loginType="loginType"
                :miniprogramFlag="miniprogramFlag"
                :userBase="userBase"
                :tips="tips"
                :drawStatus="drawStatus"
                :pageDisplayContent="pageDisplayContent"
                :tipsMessage="tipsMessage"
                :tipsMessageCode="tipsMessageCode"
                :imgDataObtainDone="imgDataObtainDone"
                @pointer="pointer"
                @goWinnerList="goWinnerList"
                @viewRecord="viewRecord"
                @openGuide="openGuide"
                @goHiHonorMiniProgram="goHiHonorMiniProgram"
                @nextStep="nextStep"
                @updateIsShowIdentityDialog="updateIsShowIdentityDialog">
            </big-wheel>
        </div>
        <!-- 盲盒 -->
        <div v-if="bigWheelActivityType === '2'">
            <blind-box :isLoginFlag="isLoginFlag"
                :bannerPic="bannerPic"
                :drawPointConsumption="drawPointConsumption"
                :poinsOrDiamonds="poinsOrDiamonds"
                :activityStatus="activityStatus"
                :participateTimes="Number(participateTimes)"
                :guideLotteryUrl="guideLotteryUrl"
                :whetherActivity="whetherActivity"
                :regularDrawShowStatus="regularDrawShowStatus"
                :drawWheelType="drawWheelType"
                :participateType="participateType"
                :userNum="userNum"
                :headerList="headerList"
                :hasMask="hasMask"
                :winningRate="winningRate"
                :drawWheelUrl="drawWheelUrl"
                :drawPointUrl="drawPointUrl"
                :pointDrawFlag="pointDrawFlag"
                :miniprogramFlag="miniprogramFlag"
                :loginType="loginType"
                :activityUrl="activityUrl"
                :drawType="drawType"
                :boxIndex="boxIndex"
                :tips="tips"
                :canDrawFlag="canDrawFlag"
                :activityObj="activityObj"
                :tigerLottery="tigerLottery"
                :winnerList="winnerList"
                :ruleDesci="ruleDesci"
                :sectionThreeColor="sectionThreeColor"
                :bigWheelRewardList="bigWheelRewardList"
                :bigWheelActivityType="bigWheelActivityType"
                :pointsValue="pointsValue"
                :memberInfo="memberInfo"
                :myRecord="myRecord"
                :myRecords="myRecords"
                :bgColor="bgColor"
                :classOption="classOption"
                :awardNum="awardNum"
                :userBase="userBase"
                :drawStatus="drawStatus"
                :pageDisplayContent="pageDisplayContent"
                :tipsMessage="tipsMessage"
                :tipsMessageCode="tipsMessageCode"
                @goLottery="goLottery"
                @pointer="pointer"
                @goWinnerList="goWinnerList"
                @viewRecord="viewRecord"
                @openGuide="openGuide"
                @goHiHonorMiniProgram="goHiHonorMiniProgram"
                @nextStep="nextStep"
                @updateIsShowIdentityDialog="updateIsShowIdentityDialog"></blind-box>
        </div>
        <!-- 轮盘锦鲤 -->
        <div v-if="bigWheelActivityType === '3'">
            <roulette-koi ref="rouletteKoi"
                :isLoginFlag="isLoginFlag"
                :tips="tips"
                :bannerPic="bannerPic"
                :bgColor="bgColor"
                :tigerLottery="tigerLottery"
                :tigerBgColor="tigerBgColor"
                :activityObj="activityObj"
                :bigWheelRewardList="bigWheelRewardList"
                :participateTimes="Number(participateTimes)"
                :pointDrawFlag="pointDrawFlag"
                :activityStatus="activityStatus"
                :drawType="drawType"
                :miniprogramFlag="miniprogramFlag"
                :loginType="loginType"
                :winnerList="winnerList"
                :bigWheelActivityType="bigWheelActivityType"
                :ruleDesci="ruleDesci"
                :sectionThreeColor="sectionThreeColor"
                :pointsValue="pointsValue"
                :memberInfo="memberInfo"
                :myRecord="myRecord"
                :myRecords="myRecords"
                :awardNum="awardNum"
                :classOption="classOption"
                :activityUrl="activityUrl"
                :userBase="userBase"
                :drawStatus="drawStatus"
                :pageDisplayContent="pageDisplayContent"
                :tipsMessage="tipsMessage"
                :tipsMessageCode="tipsMessageCode"
                @pointer="pointer"
                @goWinnerList="goWinnerList"
                @viewRecord="viewRecord"
                @openGuide="openGuide"
                @goHiHonorMiniProgram="goHiHonorMiniProgram"
                @tigerMachineWinningHandler="tigerMachineWinningHandler"
                @nextStep="nextStep"
                @updateIsShowIdentityDialog="updateIsShowIdentityDialog"></roulette-koi>
        </div>
        <!-- 新盲盒 -->
        <div v-if="bigWheelActivityType === BWC.BigWheelActivityType.newBlindBox">
            <new-blind-box v-if="drawWheelType !== BWC.DrawWheelType.ordinaryDraw"
                :newBlindBoxData="newBlindBoxData"
                :regularDrawShowStatus="regularDrawShowStatus"
                :showEndPage="showEndPage"
                :ruleDesci="ruleDesci"
                :myRecord="myRecord"
                :drawType="drawType"
                :tips="tips"
                :activityStatus="activityStatus"
                :drawPointConsumption="drawPointConsumption"
                :balancePonits="pointsValue"
                :participateTimes="Number(participateTimes)"
                :miniprogramFlag="miniprogramFlag"
                :pointDrawFlag="pointDrawFlag"
                :userNum="userNum"
                :userWinNum="userWinNum"
                :loginType="loginType"
                :userBase="userBase"
                :newWinnerList="winnerList"
                :activityUrl="activityUrl"
                :newWinningRate="winningRate"
                :isLoginFlag="isLoginFlag"
                :activityObj="activityObj"
                :drawStatus="drawStatus"
                :pageDisplayContent="pageDisplayContent"
                :tipsMessage="tipsMessage"
                :tipsMessageCode="tipsMessageCode"
                :channelCode="channelCode"
                :bigWheelActivityType="bigWheelActivityType"
                @closeEnd="closeEnd"
                @pointer="pointer"
                @openGuide="openGuide"
                @goWinnerList="goWinnerList"
                @goHiHonorMiniProgram="goHiHonorMiniProgram"
                @nextStep="nextStep"
                @updateIsShowIdentityDialog="updateIsShowIdentityDialog"
                @goSkipPage="goSkipPage"
                @openAwardModalFromEndPage="openAwardModalFromEndPage">
            </new-blind-box>
            <!-- 普通抽奖 -->
            <general-lottery v-else
                ref="generalLotteryRef"
                :activityInfoObj="newBlindBoxData"
                :tips="tips"
                :winnerList="winnerList"
                :drawType="drawType"
                :drawPointConsumption="drawPointConsumption"
                :balancePoints="pointsValue"
                :participateTimes="Number(participateTimes)"
                :loginType="loginType"
                :isLoginFlag="isLoginFlag"
                :pointDrawFlag="pointDrawFlag"
                :isInMiniProgram="miniprogramFlag"
                :myRecord="myRecords"
                :ruleDesci="ruleDesci"
                :currentAward="currentAward"
                :activityUrl="activityUrl"
                :userType="userType"
                :activityObj="activityObj"
                :userBase="userBase"
                :drawStatus="drawStatus"
                :pageDisplayContent="pageDisplayContent"
                :tipsMessage="tipsMessage"
                :tipsMessageCode="tipsMessageCode"
                :bigWheelActivityType="bigWheelActivityType"
                @pointer="pointer"
                @nextStep="nextStep"
                @updateIsShowIdentityDialog="updateIsShowIdentityDialog"
                @refreshMyRecords="refreshMyRecords"
                @goWinnerList="goWinnerList"
                @goHiHonorMiniProgram="goHiHonorMiniProgram"
                @openReceiveAwardModal="openReceiveAwardModal"></general-lottery>
        </div>
        <!-- 结果弹窗 -->
        <result-dialog ref="resultDialog"
            :awardObj="awardObj"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            :referrFlag="userBase.referrFlag"
            :activityUrl="activityUrl"
            :drawType="drawType"
            :miniprogramFlag="miniprogramFlag"
            :userInfoList="userInfoList"
            :isFilledFlag="isFilledFlag"
            @getRecord="getRecord"
            @nextStep="nextStep"
            @openKindAwardModal="openKindAwardModal"
            @openVirtualAwardModal="openVirtualAwardModal"
            @openReceiveAwardModal="openReceiveAwardModal"></result-dialog>
        <!--分享标签：微信hihonor小程序内且是启用分享且是分享抽奖且是进行中大转盘活动才显示-->
        <share-tag v-if="showShareTag"
            :remainingSharingTimes="Number(remainingSharingTimes)"
            :bigWheelActivityType="bigWheelActivityType"
            :activityConfig="activityObj.activityConfig"
            @openGuide="openGuide">
        </share-tag>
        <!-- 分享指引 -->
        <guideModal ref="guideModal"
            :isWechat="!miniprogramFlag && loginType == 'wechat'"></guideModal>
        <!-- 选择门店的弹窗 -->
        <store-modal ref="storeModal"
            :activityCode="activityCode"
            :currentStore="currentStore"
            @changeStore="changeStoreHandler"></store-modal>
        <!-- 开启定位弹窗 -->
        <van-dialog v-model="showGetLocationNotice"
            show-cancel-button
            confirm-button-text="开启定位"
            cancel-button-text="选择活动门店"
            confirmButtonColor="#256fff"
            @confirm="obtainLocation"
            @cancel="selectStore">
            <div class="dialog-contain">
                <div class="message">您当前未开启定位，无法获取离您最近的活动门店，请开启定位或选择活动门店，再参与该活动！</div>
            </div>
        </van-dialog>
        <!-- 门店确认弹窗 -->
        <van-dialog v-model="showSelectStoreNotice"
            show-cancel-button
            confirm-button-text="到该店参与活动"
            cancel-button-text="选择其他活动门店"
            confirmButtonColor="#256fff"
            @confirm="confirmStore"
            @cancel="selectStore">
            <div class="dialog-contain">
                <div class="message">当前距您最近的活动门店是“<span class="store-name">{{ currentStore.channelName || '' }}</span>”</div>
            </div>
        </van-dialog>
        <IncorrectClient :isDisplay="!isCorrectClient"
            :loginType="originLoginType"></IncorrectClient>
        <identityVerifyDialog :isShowIdentityDialog.sync="isShowIdentityDialog"
            :verifyTitle="raffleVerifyTitle"
            :showOtherActivity="showOtherActivity"
            :isShowCheckBtn="isShowCheckBtn"
            :activityUrl="activityUrl"
            :activityCode="parentActivityCode"
            :flag="miniprogramFlag"
            :pageSource="'bigTurntable'"
            :isClickNextPage="isClickNextPage"
            :loginType="loginType"
            :getAllData="getAllData"
            :identityTypeList="customerIdentityList"
            :checkChannel="0"
            @goOtherActivity="goOtherActivity"></identityVerifyDialog>
        <!-- 抽奖对象配置，企微好友控制，企微导购弹窗 -->
        <qywx-guide-limit-modal ref="qywxGuideLimit"
            :activityType="ActivityType.bigTurnable"></qywx-guide-limit-modal>
        <!-- 抽奖对象配置，社群用户控制，社群活码弹窗 -->
        <community-user-limit-modal ref="communityUserLimit"
            :activityType="ActivityType.bigTurnable"
            :activityCode="activityCode"></community-user-limit-modal>
    </div>

</template>
<script>
import _script from './raffle-main';
export default _script;
</script>
<style scoped lang='scss'>
.raffle-main {
  width: 100%;
  height: 100%;
  max-width: 480px;
  margin: 0px auto;
  background: #5f9dff;
}
.xcx-back-btn {
  position: absolute;
  right: 0px;
  bottom: 100px;
  width: 130px;
  z-index: 99999;
}
.text {
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: auto;
  display: flex;
  align-content: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  font-size: 16px;
  position: fixed;
  .content {
    padding: 20px;
    text-align: center;
    margin-top: 50%;
    background-color: #fff;
    width: 300px;
    height: 300px;
    border-radius: 20px;
    position: absolute;
  }

  .content-community-user {
    padding: 20px;
    text-align: center;
    margin-top: 50%;
    background-color: #fff;
    width: 320px;
    height: 150px;
    border-radius: 20px;
    position: absolute;
    .community-user-tip {
      margin-top: 15px;
    }
    .confirm-button {
      color: #ee0a24;
      margin-top: 45px;
      font-size: 20px;
    }
    .deleteTips {
      z-index: 22;
      margin-top: 20px;
    }
  }
}
.dialog-contain {
  padding: 28px 15px;
  .message {
    font-family: HONORSansBrand-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 1.5;
    font-weight: 400;
    .store-name {
      font-size: 14px;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/raffle-main.vue